import axios from "../axios";

export const getProjectData = async (isAdmin = false) => {
  const url = isAdmin
    ? "/api/Project/ProjectData?isAdmin=1"
    : "/api/Project/ProjectData";

  return axios.get(url);
};
export const getProjectTeam = async (ProjectUID) => {
  return axios.get(`/api/Project/ActiveTeam/${ProjectUID}`);
};

export const getAssignedProjects = async () =>{
  return axios.get(`/api/Developer/AssignedProjects`);
};
